import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * NotFoundScreen component for displaying 404 errors
 * @param {string} type - Type of resource not found ('election' or 'vote')
 */
function NotFoundScreen({ type = 'election' }) {
    const { t } = useTranslation(['common']);

    const title = type === 'vote'
        ? t('common:errors.voteNotFound')
        : t('common:errors.electionNotFound');

    const message = type === 'vote'
        ? t('common:errors.voteNotFoundMessage')
        : t('common:errors.electionNotFoundMessage');

    return (
        <div className="not-found-container">
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6">
                        <div className="not-found-card mt-5">
                            <div className="alert alert-warning" role="alert">
                                <h4 className="alert-heading">{title}</h4>
                                <p className="mb-0">{message}</p>
                            </div>
                            <div className="not-found-nav mt-3">
                                <Link to="/" className="btn btn-primary">
                                    {t('common:navigation.backToHome')}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NotFoundScreen;
